import { NavLink } from "react-router-dom"

export default function Sidebar({ setToken }) {
  const handleLogout = () => {
    localStorage.removeItem("token")
    setToken(null)
  }
  return (
    <div className="sidebar">
      <img
        src="/logobarra.jpg"
        alt="Logo"
        className="sidebar-logo"
      />

      <nav>
        <p className="sidebar-section">Principal</p>
        <NavLink className={navClass} to="/" end>Dashboard</NavLink>
        <NavLink className={navClass} to="/dashboard-comparativos">Comparativos</NavLink>
        <NavLink className={navClass} to="/ventas">Nueva Venta</NavLink>
        <NavLink className={navClass} to="/agenda">Agendar Cita</NavLink>
        <NavLink className={navClass} to="/agenda-vista">Ver Agenda</NavLink>
        <NavLink className={navClass} to="/clientes">Clientes</NavLink>

        <p className="sidebar-section">Finanzas</p>
        <NavLink className={navClass} to="/reportes">Reportes</NavLink>
        <NavLink className={navClass} to="/gastos">Gastos</NavLink>

        <p className="sidebar-section">Inventario</p>
        <NavLink className={navClass} to="/inventario">Inventario</NavLink>
        <NavLink className={navClass} to="/movimientos-inventario">Movimientos</NavLink>

        <p className="sidebar-section">Configuración</p>
        <NavLink className={navClass} to="/estilistas">Estilistas</NavLink>
        <NavLink className={navClass} to="/servicios">Servicios</NavLink>

        <button onClick={handleLogout} className="btn-logout">
          Cerrar Sesión
        </button>
      </nav>
    </div>
  )
}

// Usa NavLink: agrega la clase "active" automáticamente a la ruta activa
function navClass({ isActive }) {
  return isActive ? "sidebar-link sidebar-link--active" : "sidebar-link"
}
